// extracted by mini-css-extract-plugin
export default {"modalBodyStyle":"ArgumentPicker_modalBodyStyle__68wK9"};